import { createStructuredSelector, createSelector } from "reselect";
import moment from "moment";
import { workareaSelector } from "features/workarea/selectors";
import { organizationSelector } from "features/organization/selectors";
import { soloLookupSelector } from "../../../app/soloLookup/selectors";

export const soloConfirmFiles = state =>
  state.solo.getIn(["confirm", "soloConfirmFiles"]);
// returns an object indexed by pk (not sorted)
export const soloConfirmFilesSelector = createSelector(soloConfirmFiles, x =>
  x.toJS()
);

// returns a sorted array
export const soloConfirmFilesListSelector = createSelector(
  soloConfirmFiles,
  x =>
    x
      .toList()
      .filter(a => a.get("annotatedDate"))
      .sortBy(a => moment(a.get("annotatedDate")))
      .reverse()
      .toJS()
);

export const soloConfirmFilesDidInvalidateSelector = state =>
  state.solo.getIn(["confirm", "soloConfirmFilesDidInvalidate"]);
export const soloConfirmFilesFetchingSelector = state =>
  state.solo.getIn(["confirm", "soloConfirmFilesFetching"]);
export const soloCastsFetchingSelector = state =>
  state.solo.getIn(["confirm", "soloCastsFetching"]);

export const soloFilesBeingConfirmed = state =>
  state.solo.getIn(["confirm", "soloFilesBeingConfirmed"]).toSet();
export const soloFilesBeingConfirmedSelector = createSelector(
  soloFilesBeingConfirmed,
  x => x.toJS()
);
export const soloFetchedFilePks = state =>
  state.solo
    .getIn(["confirm", "soloCastsInFiles"])
    .keySeq()
    .map(x => parseInt(x, 10))
    .toSet();
export const soloFetchedFilePksSelector = createSelector(
  soloFetchedFilePks,
  x => x.toJS()
);

export const soloCastsInFiles = state =>
  state.solo.getIn(["confirm", "soloCastsInFiles"]);
export const soloCastsInFilesSelector = createSelector(soloCastsInFiles, x =>
  x.toJS()
);

export const soloFilesToRecall = state =>
  state.solo.getIn(["confirm", "soloFilesToRecall"]).toSet();
export const soloFilesToRecallSelector = createSelector(soloFilesToRecall, x =>
  x.toJS()
);

export const soloRecallingFilesSelector = state =>
  state.solo.getIn(["confirm", "soloRecallingFiles"]);

export const soloConfirmStartDateFilterSelector = state =>
  state.solo.getIn(["confirm", "soloConfirmStartDateFilter"]);

export const soloConfirmEndDateFilterSelector = state =>
  state.solo.getIn(["confirm", "soloConfirmEndDateFilter"]);

export const soloConfirmInstrumentNumFilterSelector = state =>
  state.solo.getIn(["confirm", "soloConfirmInstrumentNumFilter"]);

export default createStructuredSelector({
  soloConfirmFiles: soloConfirmFilesSelector,
  soloConfirmFilesList: soloConfirmFilesListSelector,
  soloConfirmFilesDidInvalidate: soloConfirmFilesDidInvalidateSelector,
  soloConfirmFilesFetching: soloConfirmFilesFetchingSelector,
  soloCastsFetching: soloCastsFetchingSelector,
  soloFilesBeingConfirmed: soloFilesBeingConfirmedSelector,
  soloFetchedFilePks: soloFetchedFilePksSelector,
  soloCastsInFiles: soloCastsInFilesSelector,
  soloFilesToRecall: soloFilesToRecallSelector,
  soloRecallingFiles: soloRecallingFilesSelector,
  workarea: workareaSelector,
  organization: organizationSelector,
  soloConfirmStartDateFilter: soloConfirmStartDateFilterSelector,
  soloConfirmEndDateFilter: soloConfirmEndDateFilterSelector,
  soloConfirmInstrumentNumFilter: soloConfirmInstrumentNumFilterSelector,
  soloUIDLookup: soloLookupSelector
});
